    import { create } from 'zustand';
    import { BarcodeDto } from 'src/dtos/barcode/barcodeDto';

    // 바코드 입력 항목 인터페이스
    export interface BarcodeInputItem {
        barcode: string;
        itemCd: string;
        itemNm?: string;
        itemSpec?: string;
        modelNo?: string;
        packQty: number;
        itemUnit?: string;
        remark?: string;
        isExisting: boolean; // DB에 존재하는지 여부
        isEditable: boolean; // 입력 가능한지 여부 (DB에 없으면 true)
    }

    interface PDA1110_R01State {
    loading: boolean;
    setLoading: (loading: boolean) => void;
    
    // 바코드 입력 리스트
    barcodeInputList: BarcodeInputItem[];
    addBarcodeInput: (barcode: string, existingInfo?: BarcodeDto) => void;
    updateBarcodeInput: (index: number, updates: Partial<BarcodeInputItem>) => void;
    removeBarcodeInput: (index: number) => void;
    
    // 초기화
    reset: () => void;
    }

    const initialState = {
    loading: false,
    barcodeInputList: [{
        barcode: '',
        itemCd: '',
        packQty: 1,
        isExisting: false,
        isEditable: true,
    }],
    };

    const usePDA1110_R01Store = create<PDA1110_R01State>((set) => ({
    ...initialState,
    
    setLoading: (loading) => set({ loading }),
    
    addBarcodeInput: (barcode, existingInfo) => {
        const normalizedBarcode = barcode.trim().toUpperCase();
        
        set((state) => {
            // 리스트가 비어있거나 첫 번째 항목이 빈 항목이면 업데이트
            if (state.barcodeInputList.length === 0 || (state.barcodeInputList.length === 1 && !state.barcodeInputList[0].barcode)) {
                const newItem: BarcodeInputItem = existingInfo ? {
                    barcode: normalizedBarcode,
                    itemCd: existingInfo.itemCd || '',
                    itemNm: existingInfo.itemNm,
                    itemSpec: existingInfo.itemSpec,
                    modelNo: existingInfo.modelNo,
                    packQty: existingInfo.packQty || 1,
                    itemUnit: existingInfo.itemUnit || '',
                    remark: existingInfo.remark,
                    isExisting: true,
                    isEditable: false, // 기존 데이터는 수정만 가능
                } : {
                    barcode: normalizedBarcode,
                    itemCd: '',
                    packQty: 1,
                    isExisting: false,
                    isEditable: true, // 새 바코드는 입력 가능
                };
                
                return {
                    ...state,
                    barcodeInputList: [newItem],
                };
            }
            
            // 이미 항목이 있으면 추가하지 않음 (하나의 폼만 유지)
            return state;
        });
    },
    
    updateBarcodeInput: (index, updates) => {
        set((state) => {
            const newList = [...state.barcodeInputList];
            if (newList[index]) {
                newList[index] = { ...newList[index], ...updates };
            }
            return { ...state, barcodeInputList: newList };
        });
    },
    
    removeBarcodeInput: (index) => {
        set((state) => {
            const newList = state.barcodeInputList.filter((_, i) => i !== index);
            return { ...state, barcodeInputList: newList };
        });
    },
    
    reset: () => set(initialState),
    }));

    export default usePDA1110_R01Store;
